//find every element with data-rotate attribute
var elements = document.querySelectorAll('[data-rotate]');
// check if they have transform property, if so add to beginning of transform: rotate([value]deg)

window.onload = () => {
    elements.forEach(function(element) {
        var rotate = element.getAttribute('data-rotate');
        var transform = element.style.transform;
        if (transform) {
            element.style.transform =  + transform + 'rotate(' + rotate + 'deg) ';
        } else {
            element.style.transform = 'rotate(' + rotate + 'deg)';
        }
    })

    document.querySelector(".header-toggle").addEventListener("click", function() {
        // document.querySelector(".header-dropdown").classList.toggle("expanded");
    });
}

let toggle = document.querySelector("#toggle");
let expander = document.querySelector(".expander");


//find every document.querySelectorAll(".cart_attr.active") element
//get their parent's data-option-type. accumulate an object with the data-option-type as key and the textContent of the element as value
const getProps = () => {
    let props = {};
    document.querySelectorAll(".cart_attr.active").forEach(el => {
        let type = el.parentNode.parentNode.getAttribute("data-option-type");
        let value = el.textContent;
        props[type] = value;
    });
    return props;
}

const buttonListener = (e) => {
    e.preventDefault();
    let variant = e.target.getAttribute('data-add-variant');
    let quantity = e.target.getAttribute('data-add-q');
    let props = getProps();
    processCartUpdate(variant,quantity, props);
}

const quantityListener = (e) => {
    e.preventDefault();
    let variant = e.target.closest(".cart-item").getAttribute('data-variant');
    let initialQuantity = parseInt(e.target.getAttribute('data-initial-q'));
    let newQuantity = parseInt(e.target.value);
    //ignore empty/invalid input and restore the previous value
    if (isNaN(newQuantity) || newQuantity < 0) {
        e.target.value = initialQuantity;
        return;
    }
    if (newQuantity === initialQuantity) return;
    //set the absolute quantity directly (0 removes the item)
    changeCart(variant,newQuantity);
}

const installButtonListeners = (e) => {
    document.querySelectorAll('[data-add-variant]').forEach(anchor => {
        //check if the element has an event listener, if so remove it
        anchor.removeEventListener('click', buttonListener);
        anchor.addEventListener('click', buttonListener);
    });
    //add back handlers from other file
    document.querySelectorAll("[data-modal-toggle]").forEach(anchor => {
        //check if the element has an event listener, if so remove it
        anchor.removeEventListener('click', window.handlers.modalToggleHandler);
        anchor.addEventListener('click', window.handlers.modalToggleHandler);
    })
    //add quantity listeners to all .item-quantity elements
    document.querySelectorAll('.item-quantity').forEach(input => {
        //check if the element has an event listener, if so remove it
        //'change' fires once when editing is done (blur/enter/arrows), not on every keystroke
        input.removeEventListener('change', quantityListener);
        input.addEventListener('change', quantityListener);
    });

}

installButtonListeners();

  //for any link named .jump, scroll to the target smoothly
document.querySelectorAll('.jump').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
        let href = this.getAttribute('href');
        if(href.indexOf("#") > -1){
            e.preventDefault();
            const targetElement = document.querySelector(this.getAttribute('href'));
            const yOffset = -1*window.innerWidth*0.135; // Adjust this value to set the desired offset
            const y = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;

            window.scrollTo({
                top: y,
                behavior: 'smooth'
            });
        }
    });
});

//save the cart in window.object and update the cart count in the header
window.cart_reset = (data,variant) => {
    if(data && data?.sections['cart-drawer'] || data && data?.sections['cart-page']){
        // document.querySelector('#cart-drawer-section').innerHTML = data.sections['cart-drawer'];
        //instead of the line above, please take the inner ".cart-items" inside data.sections['cart-drawer'] and insert it into #cart-drawer-section's .cart-items innerHTML
        let cartDrawer = document.querySelector('#cart-drawer-section #cart');
                if(cartDrawer){
                    cartDrawer.innerHTML = new DOMParser()
                                .parseFromString(data.sections['cart-drawer'], 'text/html')
                                .querySelector('#cart').innerHTML;
                    //if variant, show only the cart item with data-variant match
                    if(variant){
                        let cartItems = cartDrawer.querySelectorAll('.cart-item');
                        cartItems.forEach(item => {
                            if(item.getAttribute('data-variant') != variant){
                                item.remove();
                            }
                        });
                    }
                }
            let cartPage = document.querySelector('.cart-page');
                if(cartPage){
                    cartPage.innerHTML = new DOMParser()
                                .parseFromString(data.sections['cart-page'], 'text/html')
                                .querySelector('.cart-page').innerHTML;
                }

        if(!document.querySelector('#cart-wrapper').classList.contains('active')){
            toggleModal("cart")
        }
    }
    fetch("/cart.js").then(response => response.json()).then(data => {
        window.cart = data;
        // console.log("cart",window.cart)
        document.querySelectorAll('.cart-count').forEach(el => {
            el.innerText = data.item_count;
        });
    });
    installButtonListeners();
}

cart_reset();

// a scheme based on the attribute "data-add-variant".
//this adds or removes variants from the cart. if no attribute "data-add-q" is present, it will add 1 of the variant to the cart.
//if data-add-q is present and equals 0, it will remove the variant from the cart entirely. if it's -1 or below, it will remove that many of the variant from the cart.
//if it's 1 or above, it will add that many of the variant to the cart.

const changeCart = async (variant,quantity) => await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ id: variant, quantity, sections: "cart-drawer,cart-count,cart-page" })
    }).catch((error) => {
        console.error('Error:', error);
    }).then(response => response.json()).then(data => {
        console.log("cart changed",data)
        cart_reset(data,variant);
    });

const addCart = async (variant,quantity,properties={}) => await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({items: [{ id: variant, quantity, properties }], sections: "cart-drawer,cart-count,cart-page"})
    }).catch((error) => {
        console.error('Error:', error);
    }).then(response => response.json()).then(data => {
        console.log("cart added",data)
        cart_reset(data,variant);
    });

const processCartUpdate = (variant,quantity,props) => {
    let variantAlreadyInCart = cart.items.find(item => item.variant_id == variant);
    if (variantAlreadyInCart) {
        if (quantity === "0") {
            quantity = 0;
        } else if (!quantity) {
            quantity = 1;
        }
        let newQuantity = quantity === 0 ? 0 : parseInt(variantAlreadyInCart.quantity) + parseInt(quantity);
        // console.log("newQuantity",newQuantity)
        changeCart(variant,newQuantity);
    } else {
        if (!quantity || quantity === "0") {
            quantity = 1;
        }
        console.log("adding to cart",variant,quantity,props)
        addCart(variant,quantity,props);
    }
}

// document.querySelector(".cart-toggle").click()

//search all links in both the .menu-links and .main-nav elements
//if the current url matches the href of the link, add the class .active to the link
document.querySelectorAll('.menu-links a, .main-nav a').forEach(anchor => {
    // console.log(anchor.getAttribute("href")=== window.location.pathname)
    if (anchor.getAttribute("href") == window.location.pathname) {
        anchor.classList.add('current-link');
    }
});

document.addEventListener("DOMContentLoaded", function() {
    let lazyImages = [].slice.call(document.querySelectorAll("img.lazyload"));
    if ("IntersectionObserver" in window) {
        let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    let lazyImage = entry.target;
                    lazyImage.src = lazyImage.dataset.src;
                    lazyImage.classList.remove("lazyload");
                    lazyImage.classList.add("lazyloaded");
                    lazyImageObserver.unobserve(lazyImage);
                }
            });
        });

        lazyImages.forEach(function(lazyImage) {
            lazyImageObserver.observe(lazyImage);
        });
    } else {
        // Fallback for browsers that do not support IntersectionObserver
        lazyImages.forEach(function(lazyImage) {
            lazyImage.src = lazyImage.dataset.src;
            lazyImage.classList.remove("lazyload");
            lazyImage.classList.add("lazyloaded");
        });
    }
});

// //for any element with class .browser, add class safari if the browser is safari
// if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
//     document.querySelectorAll('.browser').forEach(el => {
//         el.classList.add('safari');
//     });
// }